import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

import { PropType } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'
import { PPTVideoElement } from '@/types/slides'
import { ContextmenuItem } from '@/components/Contextmenu/types'

import VideoPlayer from './VideoPlayer/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  elementInfo: {
    type: Object as PropType<PPTVideoElement>,
    required: true,
  },
  selectElement: {
    type: Function as PropType<(e: MouseEvent | TouchEvent, element: PPTVideoElement, canMove?: boolean) => void>,
    required: true,
  },
  contextmenus: {
    type: Function as PropType<() => ContextmenuItem[] | null>,
  },
},
  setup(__props) {

const props = __props;



const { canvasScale } = storeToRefs(useMainStore())

const handleSelectElement = (e: MouseEvent | TouchEvent, canMove = true) => {
  if (props.elementInfo.lock) return
  e.stopPropagation()

  props.selectElement(e, props.elementInfo, canMove)
}

return (_ctx: any,_cache: any) => {
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-element-video", { 'lock': __props.elementInfo.lock }]),
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "element-content",
        onMousedown: _cache[2] || (_cache[2] = $event => handleSelectElement($event, false)),
        onTouchstart: _cache[3] || (_cache[3] = $event => handleSelectElement($event, false))
      }, [
        _createVNode(VideoPlayer, {
          width: __props.elementInfo.width,
          height: __props.elementInfo.height,
          src: __props.elementInfo.src,
          poster: __props.elementInfo.poster,
          scale: _unref(canvasScale)
        }, null, 8, ["width", "height", "src", "poster", "scale"]),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['t', 'b', 'l', 'r'], (item) => {
          return _createElementVNode("div", {
            class: _normalizeClass(['handler-border', item]),
            key: item,
            onMousedown: _cache[0] || (_cache[0] = $event => handleSelectElement($event)),
            onTouchstart: _cache[1] || (_cache[1] = $event => handleSelectElement($event))
          }, null, 34)
        }), 64))
      ], 32)), [
        [_directive_contextmenu, __props.contextmenus]
      ])
    ], 4)
  ], 6))
}
}

})